import React, { Component } from 'react'
 
import CV from 'react-cv'
import axios from 'axios';
import '../styles/CV.css';
import Icon from '@material-ui/core/Icon';
import MailIcon from '@material-ui/icons/Mail';
import BusinessTwoToneIcon from '@material-ui/icons/BusinessTwoTone';
import PhoneAndroidTwoToneIcon from '@material-ui/icons/PhoneAndroidTwoTone';
import LanguageTwoToneIcon from '@material-ui/icons/LanguageTwoTone';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import GitLabIcon from '@material-ui/icons/GitHub';
import GitHubIcon from '@material-ui/icons/GitHub';
import { Divider } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import profile from "../img/circle-cropped.png";

class PDF extends Component {

    constructor(props) {
        super(props)
    
        
          
          
        this.state = {
          
          currentStep: 1,
    
          Name_Surname:'',
          Nomination :'',
          Description : '',
          Prof_img : '',
          Link1 :'',
          Link2 :''  ,
          Link3 : '' ,
          Contact :[
                     
                   ],
         
          Skills :[
            {
              Skills_Name : '',
              Sklls_img : '',
            }
          ],
         
          Experiences :[
            {
              Position :'',
              Company : '',
              Exp_Date_B :'',
              Exp_Date_E :'',
    
            }
          ],
         
    
          Education:[
            {
              Level :'',
              University :'',
              Educ_Date_B : '',
              Educ_Date_E : '',
    
            }
          ],
          
          Project:[
            {
              Proj_Name : '',
              Proj_Description :'',
              Proj_Picture :'',
            }
          ]
         
        }}
    componentDidMount(){
        axios.get('https://api-backend-portfolio.herokuapp.com/profiles/5ec5b5f80d6ac6001714ca28')
             .then(response =>{
              this.setState({
                
    
                
                  Nomination :response.data.About.Nomination,
                  Description : response.data.About.Description,
                  Name_Surname : response.data.About.Name_Surname,
                  Prof_img :response.data.About.Prof_img,
                  Link1 :response.data.About.Link1,
                  Link2 :response.data.About.Link2,
                  Link3 :response.data.About.Link3,
            
                  Contact : response.data.Contact,
                  Skills: response.data.Skills,
                  Experiences:response.data.Experiences,
                  Education:response.data.Education,
                  Project:response.data.Project,
                  
                 // this.state.Contact.map(cantact=> ())
                
      
              })
            
             })
             .catch(function(error){
               console.log(error);
             })
      }

  render () {
    return (
      <React.Fragment>
             

        <div id="cv" class="instaFade">
        <Paper elevation={3}>
	<div class="mainDetails">
		<div id="headshot" class="quickFade">
			<img src={profile} alt="Berriri Sahbi" />
		</div>
		
		<div id="name">
			<h1 class="quickFade delayTwo">{this.state.Name_Surname}</h1>
			<h2 class="quickFade delayThree">{this.state.Nomination}</h2>
		</div>
    

		<div id="contactDetails" class="quickFade delayFour">

   { this.state.Contact.map(cantact=> (
      <ul>
				<li><MailIcon color="primary"/> <a href={cantact.E_mail} target="_blank">{cantact.E_mail}</a>  </li>
			<li><BusinessTwoToneIcon color="primary"/> {cantact.Address} </li>
      	
        <li><PhoneAndroidTwoToneIcon color="primary"/>{cantact.Phone}</li>
        </ul>
    ))}
		
      <hr/>
     
		</div>
    
		<div class="clear"></div>

    <Grid container spacing={3}>
    <Grid item xs>
      <LanguageTwoToneIcon color="primary"/> <a href={this.state.Link1}>{this.state.Link2}</a> 
    </Grid>
    <Grid item xs>
      <LinkedInIcon color="primary"/> <a href={this.state.Link2}>{this.state.Link2}</a>
    </Grid>
     <Grid item xs>
      <GitHubIcon color="primary"/> <a  href={this.state.Link3}>{this.state.Link3}</a> 
      </Grid>
    </Grid>
       

      
	</div>
	
	<div id="mainArea" class="quickFade delayFive">
		<section>
			<article>
				<div class="sectionTitle">
					<h1>Personal Profile</h1>
				</div>
				
				<div class="sectionContent">
   <p>{this.state.Description}</p>
				</div>
			</article>
			<div class="clear"></div>
		</section>
		
		
		<section>
			<div class="sectionTitle">
				<h1>Work Experience</h1>
			</div>
			
			<div class="sectionContent">
      { this.state.Experiences.map(Exp=> (
				<article>
					<h2>{Exp.Position}</h2>
      <p class="subDetails">{Exp.Exp_Date_B} -- {Exp.Exp_Date_E}</p>
					<p>{Exp.Company}</p>
				</article>
      ))}
			
			</div>
			<div class="clear"></div>
		</section>
		
    
		<section>
			<div class="sectionTitle">
				<h1>Key Skills</h1>
			</div>
			
			<div class="sectionContent">
				<ul class="keySkills">
        { this.state.Skills.map(Skill=> (
					<li>{Skill.Skills_Name}  | {Skill.Sklls_img}</li>
        ))}
				
				</ul>
			</div>
			<div class="clear"></div>
		</section>
		
		
		<section>
			<div class="sectionTitle">
				<h1>Education</h1>
			</div>
			
			<div class="sectionContent">
      { this.state.Education.map(Educ=> (
				<article>
					<h2>{Educ.University}</h2>
					<p class="subDetails">{Educ.Level}</p>
      <p>{Educ.Educ_Date_B} -- {Educ.Educ_Date_E}</p>
				</article>
      ))}
			
			</div>
			<div class="clear"></div>
		</section>
		
    <section>
			<div class="sectionTitle">
				<h1> Projects</h1>
			</div>
			
			<div class="sectionContent">
			
        { this.state.Project.map(Proj=> (
						<article>
            <h2>{Proj.Proj_Name}</h2>
            <p class="subDetails">{Proj.Proj_Description}</p>
        <p>{Proj.Proj_Picture}</p>
          </article>
        ))}
				
			
			</div>
			<div class="clear"></div>
		</section>

	</div>
</Paper>
</div>
   
    </React.Fragment>
    )
  }
}

export default PDF